import React from 'react'
import styls from './FindStyleNodata.module.scss'

const FindStyleNodatasvg = '/assets/img/Menstylesnodata.svg'

function FindStyleNodata() {
  return (
    <>
      <div className={styls.FindStyleNodatamain}>
        <div className={styls.FindStyleNodatabox}>
          <img src={FindStyleNodatasvg} alt="FindStyleNodatasvg" />
          <p>We don't have any trending products right now, please check back soon!</p>
        </div>
      </div>
    </>
  )
}

export default FindStyleNodata
